import type { ClientCompany } from '../../types';

import { useApiRead } from 'api-read-hook';
import { subDays } from 'date-fns';
import { css, html } from 'react-strict-dom';

import { Api } from '../../api';
import { PageError, PageLoading } from '../../components';
import { Model } from '../../models';
import { formatAsDate, values } from '../../util';
import { KpiTile } from '../client-bi';

type Props = Readonly<{
  company: Api.Company.V_AdminList | ClientCompany;
}>;

export default function CompanyBi({ company }: Props) {
  const fromDate = formatAsDate(subDays(new Date(), 30));
  const toDate = formatAsDate(new Date());

  const api = useApiRead<Record<string, Model.Kpi.View>>(
    `/company-data/${company.slug}/kpis/all/${fromDate}/${toDate}`
  );

  if (api.error) return <PageError {...api} />;
  if (!api.data) return <PageLoading />;

  return (
    <html.div style={styles.kpisWrap}>
      {values(api.data)
        .slice(0, 2)
        .map((kpi) => (
          <KpiTile key={kpi.title} companySlug={company.slug} kpi={kpi} />
        ))}
    </html.div>
  );
}

const styles = css.create({
  kpisWrap: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
  },
});
